module.exports = __webpack_public_path__ + "images/directory/carousel/mvp.d8fddd80d1c4892b11a0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/carousel/mvp.png
// module id = Q/wR
// module chunks = 0